import { get, post, del } from './client.js'
import { useBridgeStore } from '../stores/bridge.js'
import { withFreshToken } from './tokenProvider.js'

function bridgeQuery() {
  const bridge = useBridgeStore()
  return new URLSearchParams({
    scopedToken: bridge.scopedToken ?? '',
    apiUrl: bridge.apiUrl ?? '',
    projectCode: bridge.projectCode ?? '',
  })
}

export function listSkills(params = {}) {
  return withFreshToken(() => {
    const query = bridgeQuery()
    if (params.tag) query.set('tag', params.tag)
    if (params.query) query.set('query', params.query)
    if (params.includeShared !== undefined) query.set('includeShared', params.includeShared)
    return get(`/skills?${query}`)
  })
}

export function getSkill(name, shared = false) {
  return withFreshToken(() => {
    const query = bridgeQuery()
    if (shared) query.set('shared', '1')
    return get(`/skills/${encodeURIComponent(name)}?${query}`)
  })
}

export function saveSkill(request) {
  return withFreshToken(() => post(`/skills?${bridgeQuery()}`, request))
}

export function deleteSkill(name, shared = false) {
  return withFreshToken(() => {
    const query = bridgeQuery()
    if (shared) query.set('shared', '1')
    return del(`/skills/${encodeURIComponent(name)}?${query}`)
  })
}
